import { CubeIcon } from '@heroicons/react/24/outline';
import { Switch } from '@main/complykit';
import { useUpdateOrganizationMutation } from '@main/graphql/mutations/UpdateOrganization.admin.generated';
import { useGetOrganizationQuery } from '@main/graphql/queries/GetOrganization.generated';
import { DrawerProperty } from '@main/ui';

import { useUpdateOrganizationHandler } from './use-update-org-handler';

export const VendorsModuleSwitch = ({ orgId }: { orgId: string }) => {
  const { data } = useGetOrganizationQuery({ orgId });
  const organization = data?.organizations_by_pk;
  const [updateOrganization, { isLoading }] = useUpdateOrganizationMutation();
  const updateOrgHanlder = useUpdateOrganizationHandler(orgId);

  if (!organization) {
    return null;
  }

  return (
    <DrawerProperty>
      <DrawerProperty.Label icon={CubeIcon} id="vendors-module-label" htmlFor="vendors-module">
        Vendors module
      </DrawerProperty.Label>
      <DrawerProperty.Content px={2} display="flex" alignItems="center">
        <Switch
          id="vendors-module"
          aria-labelledby="vendors-module-label"
          isSelected={organization.is_vendors_module_enabled}
          isPending={isLoading}
          onChange={async () => {
            updateOrgHanlder(
              updateOrganization({
                organization_id: orgId,
                updatePayload: {
                  is_vendors_module_enabled: !organization.is_vendors_module_enabled,
                  ...(organization.is_vendors_module_enabled && {
                    is_vendor_approval_workflows_enabled: false,
                    is_vendor_questionnaire_ai_review_enabled: false,
                  }),
                },
              }),
            );
          }}
        />
      </DrawerProperty.Content>
    </DrawerProperty>
  );
};
